import { Component, Input} from '@angular/core';

@Component({
  selector: 'app-others-vertical-header',
  standalone: false,
  templateUrl: './others-vertical-header.component.html',
  styleUrl: '../../job-request-column-report.component.scss'
})
export class OthersVerticalHeaderComponent {
    @Input() othersTest:any
}
